/**
 * Icons - Horizontal Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initIconsHorizontal() {
        const blocks = document.querySelectorAll('.icons-horizontal');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] icons-horizontal block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initIconsHorizontal);
    } else {
        initIconsHorizontal();
    }
})();